import { createAction } from 'redux-actions';

export const getNotes = createAction('GET_NOTES');

export const setNotes = createAction('SET_NOTES');
